import { render, staticRenderFns } from "./NotificationsPanel.vue?vue&type=template&id=38b38f6b&"
import script from "./NotificationsPanel.vue?vue&type=script&lang=js&"
export * from "./NotificationsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports